import React, { PureComponent } from 'react';
import _ from 'lodash';
import defaultFields from 'variables/data/defaultBookingListingFields.json';
import { SubTitle } from 'common-components/typography';
import { Table } from '@good/ui/core';

export class HeaderFieldsItem extends PureComponent<{
  customFields: any;
  topHeight: number;
}> {
  override render() {
    const { customFields, topHeight } = this.props;

    const headers = _.isEmpty(customFields) ? defaultFields : customFields;

    return (
      <>
        {!_.isEmpty(headers) &&
          _.map(headers, (header, index) => (
            <React.Fragment key={index}>
              {header.field === 'BOOKING_DATE' && (
                <Table.Th
                  key={`header-field-item-booking-date-${header.header.replace(' ', '-')}-${index}`}
                  style={{ top: `${topHeight}px`, width: '16px' }}
                  className='nowrap'
                />
              )}
              <Table.Th
                key={`header-field-item-${header.header.replace(' ', '-')}-${index}`}
                style={{ top: `${topHeight}px` }}
                className='nowrap'
              >
                <SubTitle>{header.header}</SubTitle>
              </Table.Th>
            </React.Fragment>
          ))}
      </>
    );
  }
}
